module.exports = __webpack_public_path__ + "static/media/kanai.99d9eb08.webp";